import React, { useEffect, useState } from 'react';

import { IHttpRequest } from  '@/interfaces/IHttp';
import { container, TYPES } from  '@/inversifyconfig/container.config';

//components
import { UserImportFieldOptionsModel } from  '@/models/ApiResponseModels/UserImportFieldOptionsModel';
import UploadFieldOptions, { getAction } from  '@/components/elements/userupload/UploadFieldOptions';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import { BasicButton, CancelConfirmPanel } from 'thrive-components';

//stylingW
import '../../css/userUpload.scss';


const options = [
    {val:0, name:"Add If Empty"},
    {val:1, name:"Overwrite"},
    {val:2, name:"Ignore"}
]

const SystemAdmin =  () =>  {
    const [formFields, setFormFields] = useState<UserImportFieldOptionsModel[]>([]);
    const [newFormFields, setNewFormFields] = useState<UserImportFieldOptionsModel[]>([]);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);

    const orgId = window.location.pathname.split('Edit/')[1]
    
    const getImportOptions = () => {
        httpCall.get(`/UserImport/GetOrgImportOptions?orgId=${orgId}`)
        .then(({data}) => {
            // filter out un editable properties
            const importdata = data.filter((d:UserImportFieldOptionsModel) => !['Username', 'Password'].includes(d.propertyName));
                
            setFormFields(importdata)
            setNewFormFields(importdata);
        })
    }
    
    useEffect(() => {
        getImportOptions();
    },[])

    const updateField = (propertyName:string, value:number) => {
        setNewFormFields(newFormFields.map((ff) => {
            if(ff.propertyName === propertyName) {
                return {...ff, action: value}
            }
            return ff
        }))
    }

    const postForm = () => {
        httpCall.post(`/UserImport/SetOrgImportOptions?orgId=${orgId}`, newFormFields)
        .then(() => getImportOptions())
        .catch((err) => console.log('error: ', err))
        .finally(() => {
            setShowEditModal(false)
        });
    }

    
    return (
        <div className="user-upload-container">
            <h2 className='section-header'>
                CSV Upload Settings
            </h2>

            <p className='section-explainer'>
                Check the fields that can be updated by the CSV upload process. The unchecked fields will be locked and cannot be updated by the CSV upload process.
            </p>
            
            {!!formFields.length && 
                <>
                    <UploadFieldsReadOnly formFields={formFields}/>
                     
                    <BasicButton 
                        className='csv-edit-button'
                        content={"Edit"} 
                        ariaLabel={'Edit CSV Upload Settings'}
                        onButtonClick={(e) => {
                            e.preventDefault()
                            setShowEditModal(true)
                        }}

                    />
                </>
            }

            <ModalWrapper isOpen={showEditModal} onRequestClose={() => setShowEditModal(false)} className='sys-admin-modal edit-user-upload-settings-modal'>
                <h1>Edit User Upload Settings</h1>
                
                <UploadFieldOptions
                    formFields={formFields}
                    options={options}
                    optionFilter={(option, propertyName) => !(propertyName === 'Groups' && option.val === 0)}
                    updateField={updateField}
                />

                <CancelConfirmPanel 
                    cancelContent={'Close Modal'} 
                    confirmContent={'Save Changes'} 
                    ariaLabelCancel={'Cancel and close modal'} 
                    ariaLabelConfirm={'Close'}
                    onConfirmClick={(e) => {
                        e.preventDefault();
                        postForm();
                    }}
                    onCancelClick={(e) => {
                        e.preventDefault();
                        setNewFormFields(formFields);
                        setShowEditModal(false);
                    }}
               />
            </ModalWrapper>
        </div>
    )     
}

function UploadFieldsReadOnly({formFields}: {formFields: UserImportFieldOptionsModel[]}) {
    return  (
        <table className='user-upload-settings-table'>
            <thead className="user-upload-header">
                <tr>
                    <th>Field</th>

                    <th>User Action</th>
                </tr>
            </thead>

            <tbody>
                {formFields.map((x:UserImportFieldOptionsModel, idx: number) => (
                    <tr key={`settings-row-${idx + 1}`} className="user-upload-row">
                        <td >{x.propertyName}</td>

                        <td>{getAction(x.action)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default SystemAdmin;